<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class="" cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px; padding-top: 40px; padding-bottom: 70px"
        class="term_service"
      >
        <h1 style="text-align: center">Truthbrush Limited Warranty</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <p>
          Truthbrush (Candibell, Inc) will repair, replace, or refund any damaged Truthbrush products in cases where that damage is the result of a defect in our material or workmanship within six (6) months from the date of original retail purchase and when used in accordance with the user manual.  You can find more information about warranty coverage in our Terms of Service.

          </p>
        <p>
          The Truthbrush Limited Warranty does not cover:
          <ul>
            <li>normal wear and tear, including scratches and dents caused by improper handling or bacteria/mold accumulation due to improper cleaning or drying after use;
            </li>
            <li>batteries as they are consumables and have a limited lifespan;</li>
            <li>water damage caused by improper closure of the Truthbrush Pro tracker back cover (eg, not fully closing the tracker; improperly removing or damaging of the sealing gasket, etc)
</li>
<li>
  damages resulting from use not in accordance with the user manual (eg, damage resulting from sharp objects like a knife, razor, fingernail, etc)

</li>
          </ul>
        </p>
        <p>
            In the US or you purchased from truthbrush.com, to initiate a claim… <br>
            Please submit a request by email to our team at support@truthbrush.com to start your warranty replacement. We kindly ask you to be as detailed as possible when describing your issue, and include any relevant pictures or videos. Close-up images of damaged areas, and a wider photo of the entire tracker or hub that includes any physical damages, are helpful for our team to assist you as soon as possible.  Also, please share your proof of purchase, the email address used in your purchase and, if different, the email address used in creating your Truthbrush account.
        </p>
        <p>
          Outside of the US, to initiate a claim…<br>
          Please contact the retailer or distributor where you purchased the product.

        </p>
  
      </b-col>
    </b-row>

    <b-row style="width: 100%;" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px;; padding-bottom: 100px"
        class="term_service"
      >
        <h1 style="text-align: center">Pay-as-you-Go Extended Warranty</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <p>
          Beyond six (6) months from retail purchase date, Truthbrush (Candibell, Inc) offers an Extended Warranty for devices (the Truthbrush Pro Tracker and the Truthbrush Hub) purchased and set up as per the Truthbrush Pay-As-You-Go service and that are linked to an active account that is in good standing.  All other Truthbrush products (Including Truthbrush Classic Trackers, Truthbrush Skins and other Truthbrush products are excluded from the Truthbrush “Pay-as-you-Go” Extended Warranty.  
</p>

<p>
          The Extended Warranty does not cover:
          <ul>
            <li>normal wear and tear, including scratches and dents caused by improper handling or bacteria/mold accumulation due to improper cleaning or drying after use;
            </li>
            <li>batteries as they are consumables and have a limited lifespan;</li>
            <li>water damage caused by improper closure of the Truthbrush Pro tracker back cover (eg, not fully closing the tracker; improperly removing or damaging of the sealing gasket, etc)
</li>
<li>
  damages resulting from use not in accordance with the user manual (eg, damage resulting from sharp objects like a knife, razor, fingernail, etc)

</li>
          </ul>
        </p>
<p>
  In the US or you purchased from truthbrush.com, to initiate a claim… <br>
            Please submit a request by email to our team at support@truthbrush.com to start your warranty replacement. We kindly ask you to be as detailed as possible when describing your issue, and include any relevant pictures or videos. Close-up images of damaged areas, and a wider photo of the entire tracker or hub that includes any physical damages, are helpful for our team to assist you as soon as possible.  Also, please share your proof of purchase, the email address used in your purchase and, if different, the email address used in creating your Truthbrush account.  A Truthbrush customer service representative will contact you to give further instructions.
             </p>
        <p>
          Outside of the US, to initiate a claim…<br>
          Please contact the retailer or distributor where you purchased the product.

        </p>
        <p>
          If the Truthbrush device is determined to be eligible for a warranty replacement … <br>
          If your Truthbrush Pro Tracker is the item that’s been determined as eligible for a warranty replacement, you’ll receive a replacement tracker only.  If your Truthbrush Hub is the item that’s been determined as eligible for a warranty replacement, you’ll receive a replacement hub only.  If both your Truthbrush Pro Tracker and Truthbrush Hub have been identified as eligible for warranty replacements, you’ll receive a new replacement set. A $5 activation fee for each replacement Tracker or Hub will be charged, plus tax and shipping if applicable.

        </p>
        <p>
          If the Truthbrush device is determined to NOT be eligible for a warranty replacement … <br>
We will be happy to return the device to you.  Shipping charges will apply.

        </p>

      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
  },
};
</script>

<style lang="scss">
.term_service h2 {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .term_service h2,
  .term_service h4 {
    text-align: center;
  }
}
</style>